<span class="alert-message">
    <ohp-icon-font iconFontName="Alert" cssClass="alert-message__icon"></ohp-icon-font>
    <span class="alert-message__text">{{ message }}</span>
</span>
